import { ComplainantGender } from "../Model/ComplainantGender";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
import { Third } from "../Model/Third";
import { Query } from "../Model/Query";
export class ComplainantGenderService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(third_id, ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('complainant/gender/' + ndiligencia + '/third_id/' + third_id);
            if (!response.ok) {
                throw new Error(`Error al obtener la victima`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findOneByDiligenceNumber(ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('complainant/gender/' + ndiligencia);
            if (!response.ok) {
                throw new Error(`Error al obtener la victima`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`complainants/genderThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async createComplainantGender(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const third = new ComplainantGender({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                complainantThirId: thirdId,
                userId: getCurrentUser().id,
                secretAddress: false,
                secretPhone: false,
                lawerToAssist: false,
                divorceMeasures: false,
                lawyerPhone: " ",
                DatelawyerNotification: new Date(),
                kinshipRelationId: null,
                relationDuration: false,
                documentationRelation: false,
                previousJudgments: false,
                reportPreviousAttacker: false,
                openJudgmentAggressor: false,
                coexistsWithAggressor: false,
                abandonAggressorAddress: false,
                prohibitApproachingAggressor: false,
                prohibitCommunicatingAggressor: false,
                hasWeaponsAttacker: false,
                abandonHome: false,
                hostPossibility: false,
                contactLawSchool: false,
                childrenOfRelation: null,
                childrenAnotherRelation: false,
                prohibitsApproachingChildren: false,
                forbidCommunicatingChildren: false,
                liveWithChildren: false,
                personalSituation: " ",
                workSituationId: null,
                provisionalHousingAttribution: false,
                custodyChildren: false,
                regimeVisitsVhildren: false,
                maintenanceCredit: false,
                precautionaryMeasureJudged: false,
                measureAdopt: " ",
                prohibitResidingAggressor: false,
                placeNotReside: " ",
                forbidTheAggressorToGo: false,
                placesDoNotGo: null,
                prohibitApproximatingAggressor: false,
                peopleDoNotApproximate: " ",
                riskEvaluation: " ",
                healthcareCenterAssistance: false,
                providesOptionalPart: false,
                subsequentMedicalTreatment: false,
                partsPreviousAggressions: false,
                marriageRegimeId: null,
                HouseTypeId: null,
                directionId: null,
                homeSecurityMeasures: "",
                otherHouses: false,
                vehicles: " ",
                familyHelp: false,
            });
            const response = await this.apiService.post('complainant_gender', third.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
    async saveComplainantTraffic(complainantGender) {
        const response = await this.apiService.post('complainant_gender', complainantGender);
        if (!response.ok) {
            throw new Error(`Error al guardar el extra de diligencia trafico`);
        }
        return true;
    }
    async deleteComplainantGender(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('complainants_gender/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciante de una diligencia genero.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante.`);
        }
    }
}
